import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import Button from "../../../../components/Button";
import { Modal } from "react-bootstrap";
import api from "../../../../api/api";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Select, { components } from "react-select";
import DownloadIcon from "@mui/icons-material/Download";

const EditContainerStatusReport = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showBLRegenerateConfirm, setShowBLRegenerateConfirm] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [blRegenerated, setBlRegenerated] = useState(false);
  const [downloadingBL, setDownloadingBL] = useState(false);
  const [portsOptions, setPortsOptions] = useState([]);

  // Stamp selection states
  const [selectedStamps, setSelectedStamps] = useState({
    containerStamps: [],
    descriptionStamps: [],
    measurementStamps: [],
  });

  // Delivery Agent selection
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState("");

  // Stamp options
  const containerStampOptions = [
    "ALL DESTINATION / DELIVERY CHARGES ON ACCOUNT OF CONSIGNEE AS PER CARRIER'S TARIFF",
    "DESTINATION CHARGES COLLECT",
    "SHIPPER'S LOAD STOW, COUNT SEAL AND WEIGHT",
    "LINER DEMURRAGE / DETENTION WILL BE PAYABLE TO LINER TARIFF",
    "DESTINATION CHARGES ON ACCOUNT OF CONSIGNEE",
    "DDC COLLECT",
    "DDC PREPAID",
  ];

  const descriptionStampOptions = [
    "FREIGHT PREPAID",
    "FREIGHT COLLECT",
    "ORIGIN CHARGES PREPAID",
    "ORIGIN CHARGES COLLECT",
    "DESTINATION CHARGES PREPAID",
    "DESTINATION CHARGES COLLECT",
    "DDC COLLECT",
    "DDC PREPAID",
  ];

  const measurementStampOptions = [
    "LCL/LCL",
    "LCL/FCL",
    "FCL/FCL",
    "PART OF 40'",
    "PART OF 20'",
  ];

  // Delivery Agent options
  const deliveryAgentOptions = [
    {
      value:
        "",
      label: "None",
    },
    {
      value:
        "PARSIAN GOLDEN ROUTE INTL TPT CO.,\nADDRESS NO.5, 2ND FLOOR, SOUTH\nBOZORGMEHR, 22 ST, SAJJAD BLVD, MASHAD, IRAN\nNATIONAL CODE: 10380647995\nREGISTRATION CODE : 48440",
      label: "PARSIAN GOLDEN ROUTE INTL TPT CO.",
    },
    {
      value:
        "NOBLE LINE LOGISTICS LLC\nOFFICE#21, 7TH FLOOR (IBC) DUBAI NATIONAL INSURANCE & REINSURANCE BUILDING, PORT SAEED, DEIRA, DUBAI,UAE.",
      label: "NOBLE LINE LOGISTICS LLC",
    },
    {
      value:
        "BAHAR TARABAR KIAN INTL TPT CO.\nUNIT 503,5TH FLOOR, ZAMEN AHOO COMPLEX, MAJD\nINTERSECTION,QARANI BLVD, MASHHAD, IRAN. POSTAL\nCODE:9195812137 NATIONAL\nID:10380647961/REGISTRATION CODE-48433\nCELL:00989019085261\nTEL:+985137289031-3 FAX:+985137289034\nE MAIL:BTK.FORWARDER@GMAIL.COM",
      label: "BAHAR TARABAR KIAN INTL TPT CO.",
    },
    {
      value:
        "NEW SAKSHI ASADULLAH LTD\nAYOBI DARMAL MARKET SHAH ZAMAN WATT KANDAHAR AFGHANISTAN\n 0704441230",
      label: "NEW SAKSHI ASADULLAH LTD",
    },
    {
      value:
        "KIAN MARINE STAR Shipping & International Freight\nADDRESS : No.9 3rd Floor NIA Budling Daneshmand intersection Pasdaran Blvd Bandar Abbas -IRAN\nEMAIL:manager@kianmarinestar.com.   National ID: 14012448401\nRegistration code 23259\nTEL:076-33548354-5",
      label: "KIAN MARINE STAR Shipping & International Freight",
    },
  ];

  // Get current user and check if they can edit
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const allowedEditors = ["GFR003", "GFR009", "wMe2inT9YF9i"];
  const canEdit = allowedEditors.includes(user?.user_id);

  // Place of Issue options
  const placeOfIssueOptions = [
    { value: "Mumbai", label: "Mumbai (22)" },
    { value: "New Delhi", label: "New Delhi (11)" },
    { value: "Chennai", label: "Chennai (44)" },
    { value: "Kolkatta", label: "Kolkatta (33)" },
    { value: "Chandigarh", label: "Chandigarh (72)" }
  ];

  // Fetch ports for dropdown
  const fetchPorts = async () => {
    try {
      const res = await api.get("/ports");
      const options = res.data.map((p) => ({
        value: p.Port_names,
        label: p.Port_names,
      }));
      setPortsOptions(options);
    } catch (err) {
      console.error("Error fetching ports:", err);
    }
  };

  // GET API - Fetch enquiry details
  const fetchEnquiry = async () => {
    try {
      const response = await api.get(`/master-data/container-status-report/${id}`);
      const enquiryData = response.data.enquiry;
      setEnquiry(enquiryData);

      // Load stamps from database (if exists)
      if (enquiryData.stamps) {
        try {
          const parsedStamps = JSON.parse(enquiryData.stamps);
          setSelectedStamps(parsedStamps);
        } catch (e) {
          console.error("Error parsing stamps:", e);
        }
      }

      // Load delivery agent from database (if exists)
      if (enquiryData.delivery_agent) {
        setSelectedDeliveryAgent(enquiryData.delivery_agent);
      }
    } catch (error) {
      console.error(" Error fetching enquiry:", error);
      alert("Failed to fetch enquiry data. Please check the console.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiry();
    fetchPorts();
  }, [id]);

  const updateContainerStatusReport = async (payload) => {
    try {
      const response = await api.put(
        `/master-data/container-status-report`,
        payload
      );
      console.log(" Update Response:", response.data);

      // Set appropriate success message based on whether BL was regenerated
      if (payload.regenerateBL) {
        setBlRegenerated(true);
        setSuccessMessage("BL draft regenerated successfully! Click OK to download.");
      } else {
        setBlRegenerated(false);
        setSuccessMessage("Container Status Report updated successfully!");
      }
      setShowSuccess(true);
    } catch (error) {
      console.error("❌ Error updating container status report:", error);
      alert(
        "Failed to update container status report. Please check the console."
      );
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: enquiry ? {
      ...enquiry,
      containers: (enquiry.containerDetails || []).map(c => ({
        ...c,
        container_number: c.container_number || "",
        seal_number: c.seal_number || ""
      }))
    } : {
      customer_name: "",
      booking_id: "",
      ports_of_loading: "",
      ports_discharge: "",
      place_reciept: "",
      place_delivery: "",
      freight_terms: "",
      origin_charge_terms: "",
      destination_charge: "",
      freight_payable_at: "",
      first_shipper_name: "",
      consignee_name: "",
      container_type: "",
      container_count: "",
      number_of_documents: "",
      number_of_originals: "",
      hs_code: "",
      hs_description: "",
      gross_weight: "",
      General_Description_Goods: "",
      number_packages: "",
      container_number: "",
      liner_seal_number: "",
      custom_seal_number: "",
      freight_charges: "",
      origin_charges: "",
      dest_charge_terms: "",
      charges_unit: "",
      charges_currency: "",
      shipper_address: "",
      consignee_address: "",
      notify_party_1: "",
      notify_party_2: "",
      notify_party_1_address: "",
      notify_party_2_address: "",
      shipping_bill_number: "",
      commercial_invoice_number: "",
      shipping_bill_date: "",
      marks_and_packages: "",
      net_weight: "",
      iec_number: "",
      mode_of_transport: "",
      route_shipment: "",
      vessel_name: "",
      voyage_number: "",
      vessel_operator: "",
      agent_details: "",
      place_of_issue: "",
      date_of_issue: "",
      fob_value: "",
      est_sailing_date: "",
      cut_off_date: "",
      form_13_cut_off_date: "",
      sailing_date: "",
      shipped_onboard: "",
      cargo_arrival_notice: "",
      pul_pin_code: "",
      dol_pin_code: "",
      document_type: "",
      nature_of_cargo: "",
      containers: [],
    },
    onSubmit: () => {
      // Check if status is "Quotation Accepted" or "Shipping Instruction Created" - show normal confirm
      // Otherwise show BL regeneration warning
      if (enquiry?.Status && (enquiry.Status === "Quotation Accepted" || enquiry.Status === "Shipping Instruction Created")) {
        setShowConfirm(true);
      } else {
        setShowBLRegenerateConfirm(true);
      }
    },
  });

  // Handle confirmation for "Quotation Accepted" status (normal update)
  const handleConfirm = async () => {
    setLoadingSubmit(true);
    try {
      setShowConfirm(false);
      const payload = {
        ...formik.values,
        enquiry_id: id,
        notificationType: "shared",
        regenerateBL: false,
        stamps: selectedStamps,
        delivery_agent: selectedDeliveryAgent,
      };
      await updateContainerStatusReport(payload);
    } finally {
      setLoadingSubmit(false);
    }
  };

  // Handle BL regeneration confirmation - User clicked "Yes"
  const handleBLRegenerateYes = async () => {
    setLoadingSubmit(true);
    try {
      // First, update the container status report
      const updatePayload = {
        ...formik.values,
        enquiry_id: id,
        notificationType: "shared",
        regenerateBL: true,
        stamps: selectedStamps,
        delivery_agent: selectedDeliveryAgent,
      };

      const updateResponse = await api.put(
        `/master-data/container-status-report`,
        updatePayload
      );

      console.log("Update Response:", updateResponse.data);

      // If update was successful and needs BL regeneration, call sendBL API
      if (updateResponse.data.needsBLRegeneration) {
        // Prepare data for sendBL API - regenerateOnly mode skips WhatsApp
        const sendBLData = {
          enq_id: id,
          stamps: selectedStamps,
          deliveryAgent: selectedDeliveryAgent,
          regenerateOnly: true, // Skip WhatsApp sending during regeneration
        };

        // Call sendBL API to regenerate BL (route is /api/si-admin/sendBL)
        const blResponse = await api.post(`/si-admin/sendBL`, sendBLData);
        console.log("BL Regeneration Response:", blResponse.data);

        setBlRegenerated(true);
        setSuccessMessage("BL draft regenerated successfully! Click OK to download.");
      } else {
        setBlRegenerated(false);
        setSuccessMessage("Container Status Report updated successfully!");
      }

      // Close the modal after operation completes
      setShowBLRegenerateConfirm(false);
      setShowSuccess(true);
    } catch (error) {
      console.error("❌ Error updating container status report:", error);
      // Close modal on error too
      setShowBLRegenerateConfirm(false);
      alert(
        "Failed to update container status report. Please check the console."
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  // Handle BL regeneration confirmation - User clicked "No" (cancel everything)
  const handleBLRegenerateNo = () => {
    setShowBLRegenerateConfirm(false);
    // Do nothing - no update, no regeneration
  };

  const handleSuccessClose = async () => {
    // If BL was regenerated, download it automatically before closing
    if (blRegenerated) {
      await handleDownloadBL();
    }
    setShowSuccess(false);
    navigate("/master-data/container-status-report");
  };

  // Handle cross/close icon click - just close without downloading
  const handleSuccessCloseWithoutDownload = () => {
    setShowSuccess(false);
    navigate("/master-data/container-status-report");
  };

  // Handle download of regenerated BL
  const handleDownloadBL = async () => {
    setDownloadingBL(true);
    try {
      const response = await api.get(
        `/download-document/bl/${id}?documentName=BL Draft`,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `BL_Draft_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      // If download fails, provide option to navigate to BL list
      if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
        alert("Unable to download BL due to network error. Please go to BL List to download the BL manually.");
      } else {
        alert("Failed to download BL. Please try again or go to BL List.");
      }
    } finally {
      setDownloadingBL(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!enquiry) return <div>No data found for this enquiry.</div>;

  return (
    <>
      <Breadcrumbs />
      <form onSubmit={formik.handleSubmit}>
        <div className="row py-4">
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Customer Name"
              name="client_name"
                 placeholder="Customer Name"
              value={formik.values.client_name}
              onChange={formik.handleChange}
              disabled={true}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Booking Number"
              name="booking_id"
                 placeholder="Booking Number"
              value={formik.values.booking_id}
              onChange={formik.handleChange}
              disabled={true}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Port of Loading</label>
            <Select
              name="ports_of_loading"
              options={portsOptions}
              value={portsOptions.find(opt => opt.value === formik.values.pol)}
              onChange={(option) => formik.setFieldValue("pol", option ? option.value : "")}
              placeholder="Select Port of Loading..."
              className="basic-select"
              classNamePrefix="select"
              isDisabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Ports of Discharge</label>
            <Select
              name="ports_discharge"
              options={portsOptions}
              value={portsOptions.find(opt => opt.value === formik.values.pod)}
              onChange={(option) => formik.setFieldValue("pod", option ? option.value : "")}
              placeholder="Select Port of Discharge..."
              className="basic-select"
              classNamePrefix="select"
              isDisabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Place of Receipt"
                placeholder="Place of Receipt"
              name="Placeof_Receipt"
              value={formik.values.Placeof_Receipt}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Place of Delivery"
                placeholder="Place of Delivery"
              name="Placeof_Delivery"
              value={formik.values.Placeof_Delivery}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Freight Terms</label>
            <select
              className="form-select"
              name="freight_terms"
              value={formik.values.freight_terms}
              onChange={formik.handleChange}
              disabled={!canEdit}
            >
              <option value="">Select Freight Terms</option>
              <option value="Prepaid">Prepaid</option>
              <option value="Collect">Collect</option>
            </select>
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Origin Charge Terms"
                placeholder="Origin Charge Terms"
              name="origin_charge_terms"
              value={formik.values.origin_charge_terms}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Destination Charge"
                placeholder="Destination Charge"
              name="destination_charge"
              value={formik.values.destination_charge}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Freight Payable At"
                placeholder="Freight Payable At"
              name="freight_payable_at"
              value={formik.values.freight_terms === "Prepaid" ? "ORIGIN" : "DESTINATION"}
              disabled
              title="This field is auto-calculated based on Freight Terms. To change this value, please update the Freight Terms field."
              style={{ cursor: "not-allowed", backgroundColor: "#f5f5f5" }}
            />
          </div>

          {/* Shipper / Consignee Info */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipper Name"
                placeholder="Shipper Name"
              name="first_shipper_name"
              value={formik.values.first_shipper_name}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Consignee Name"
              placeholder="Consignee Name"
              name="first_consignee_name"
              value={formik.values.first_consignee_name}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Container Info */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Container Type"
              placeholder="Container Type"
              name="container_type"
              value={formik.values.container_type}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Container Count"
              placeholder="Container Count"
              name="number_of_containers"
              value={formik.values.number_of_containers}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Number of Documents"
              placeholder="Number of Documents"
              name="document_count"
              value={formik.values.document_count}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="HS Code"
              placeholder="HS Code"
              name="hs_code"
              value={formik.values.hs_code}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="HS Description"
              placeholder="HS Description"
              name="hs_description"
              value={formik.values.hs_description}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Gross Weight"
                placeholder="Gross Weight"
              name="gross_weight"
              value={formik.values.gross_weight}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="General Description of Goods"
              placeholder="General  Description of Goods"
              name="general_description"
              type="textarea"
              value={formik.values.general_description}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Number of Packages"
              placeholder="Number of Packages"
              name="packaging_count"
              value={formik.values.packaging_count}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Container Table for assigning container_number and seal_number */}
          {formik.values.containers && formik.values.containers.length > 0 && (
            <div className="col-12 mb-3">
              <h5 className="fs-6 fw-bold">
                Please Assign Container Number and Seal Number to the following containers.
              </h5>
              <table className="table table-bordered" style={{ marginTop: '10px' }}>
                <thead>
                  <tr>
                    {enquiry?.shipment_segment !== "LE" && enquiry?.shipment_segment !== "LI" && (
                      <th>Container Type</th>
                    )}
                    <th>Weight</th>
                    <th>Length</th>
                    <th>Height</th>
                    <th>Breadth</th>
                    {enquiry?.nature_of_cargo === "Temperature Control" && (
                      <th>Temperature</th>
                    )}
                    <th>Container Number</th>
                    <th>Seal Number</th>
                  </tr>
                </thead>
                <tbody>
                  {formik.values.containers.map((container, index) => (
                    <tr key={index}>
                      {enquiry?.shipment_segment !== "LE" && enquiry?.shipment_segment !== "LI" && (
                        <td>{container.container_type}</td>
                      )}
                      <td>{container.container_weight}</td>
                      <td>{container.container_length}</td>
                      <td>{container.container_height}</td>
                      <td>{container.container_breadth}</td>
                      {enquiry?.nature_of_cargo === "Temperature Control" && (
                        <td>{container.container_temperature}</td>
                      )}
                      <td>
                        <InputField
                          name={`containers.${index}.container_number`}
                          placeholder="Enter Container Number"
                          value={formik.values.containers[index]?.container_number || ""}
                          onChange={formik.handleChange}
                          disabled={!canEdit}
                        />
                      </td>
                      <td>
                        <InputField
                          name={`containers.${index}.seal_number`}
                          placeholder="Enter Seal Number"
                          value={formik.values.containers[index]?.seal_number || ""}
                          onChange={formik.handleChange}
                          disabled={!canEdit}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Freight Charges"
              placeholder="Freight Charges"
              name="freight_charges"
              value={formik.values.freight_charges}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Origin Charges"
              placeholder="Origin Charges"
              name="origin_charges"
              value={formik.values.origin_charges}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Destination Charge Terms"
              placeholder="Destination Charge Terms"
              name="dest_charge_terms"
              value={formik.values.dest_charge_terms}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Charges Unit"
              placeholder="Charges Unit"
              name="charges_unit"
              value={formik.values.charges_unit}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Charges Currency"
              placeholder="Charges Currency"
              name="charges_currency"
              value={formik.values.charges_currency}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Address Fields */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipper Address"
              placeholder="Shipper Address"
              name="first_shipper_address"
              value={formik.values.first_shipper_address}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Consignee Address"
              placeholder="Consignee Address"
              name="first_consignee_address"
              value={formik.values.first_consignee_address}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 1"
              placeholder="Notify Party 1"
              name="notify_party_1"
              value={formik.values.notify_party_1}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 2"
              placeholder="Notify Party 2"
              name="notify_party_2"
              value={formik.values.notify_party_2}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 1 Address"
              placeholder="Notify Party 1 Address"
              name="notify_party_1_address"
              value={formik.values.notify_party_1_address}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Notify Party 2 Address"
              placeholder="Notify Party 2 Address"
              name="notify_party_2_address"
              value={formik.values.notify_party_2_address}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Shipping Bill Info */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipping Bill Number"
              placeholder="Shipping Bill Number"
              name="shipping_bill_number"
              value={formik.values.shipping_bill_number}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Commercial Invoice Number"
              placeholder="Commercial Invoice Number"
              name="commercial_invoice_number"
              value={formik.values.commercial_invoice_number}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipping Bill Date"
              placeholder="Shipping Bill Date"
              name="shipping_bill_date"
              value={formik.values.shipping_bill_date}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Marks Number Packages"
              placeholder="Marks Number Packages"
              name="marks_and_packages"
              type="textarea"
              value={formik.values.marks_and_packages}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Net Weight"
              placeholder="Net Weight"
              name="net_weight"
              value={formik.values.net_weight}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="IEC Number"
              placeholder="IEC Number"
              name="iec_number"
              value={formik.values.iec_number}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Transport Details */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Mode of Transport"
              placeholder="Mode of Transport"
              name="mode_of_transport"
              value={formik.values.mode_of_shipment}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Route/Shipment"
              placeholder="Route/Shipment"
              name="route_shipment"
              value={formik.values.route_shipment}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Vessel Name"
              placeholder="Vessel Name"
              name="vessel_name"
              value={formik.values.vessel_name}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Voyage Number"
              placeholder="Voyage Number"
              name="voyage_number"
              value={formik.values.voyage_number}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Vessel Operator"
              placeholder="Vessel Operator"
              name="vessel_operator"
              value={formik.values.vessel_operator}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Agent Details"
              placeholder="Agent Details"
              name="agent_details"
              value={formik.values.agent_details}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Issue Details */}
          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Place of Issue</label>
            <Select
              name="place_of_issue"
              options={placeOfIssueOptions}
              value={placeOfIssueOptions.find(opt => opt.value === formik.values.place_of_issue)}
              onChange={(option) => formik.setFieldValue("place_of_issue", option ? option.value : "")}
              placeholder="Select Place of Issue..."
              className="basic-select"
              classNamePrefix="select"
              isDisabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Date of Issue</label>
            <input
              type="date"
              name="date_of_issue"
              className="form-control"
              value={formik.values.date_of_issue ? formik.values.date_of_issue.split('T')[0] : ""}
              onChange={(e) => formik.setFieldValue("date_of_issue", e.target.value)}
              placeholder="Select Date of Issue"
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="FOB Value"
              placeholder="FOB Value"
              name="fob_value"
              value={formik.values.fob_value}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Dates */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Est. Sailing Date"
              placeholder="Est. Sailing Date"
              name="est_sailing_date"
              value={formik.values.est_sailing_date}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Cut Off Date"
              placeholder="Cut Off Date"
              name="cut_off_date"
              value={formik.values.cut_off_date}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Form 13 Cut Off Date"
              placeholder="Form 13 Cut Off Date"
              name="form_13_cut_off_date"
              value={formik.values.form_13_cut_off_date}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Sailing Date"
              placeholder="Sailing Date"
              name="sailing_date"
              value={formik.values.sailing_date}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Shipped Onboard"
              placeholder="Shipped Onboard"
              name="shipped_onboard"
              value={formik.values.shipped_onboard}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Cargo & PIN */}
          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Cargo Arrival Notice"
              placeholder="Cargo Arrival Notice"
              name="cargo_arrival_notice"
              value={formik.values.cargo_arrival_notice}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="PUL PIN Code"
              placeholder="PUL PIN Code"
              name="pul_pin_code"
              value={formik.values.pul_pin_code}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="DOL PIN Code"
              placeholder="DOL PIN Code"
              name="dol_pin_code"
              value={formik.values.dol_pin_code}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Document Type"
              placeholder="Document Type"
              name="document_type"
              value={formik.values.document_type}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Number of Originals"
              placeholder="Number of Originals"
              name="number_of_originals"
              type="number"
              value={formik.values.number_of_originals || ''}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          <div className="col-sm-6 col-md-4 mb-3">
            <InputField
              label="Nature of Cargo"
              placeholder="Nature of Cargo"
              name="nature_of_cargo"
              value={formik.values.nature_of_cargo}
              onChange={formik.handleChange}
              disabled={!canEdit}
            />
          </div>

          {/* Stamp Selection for BL - Single Dropdown with Multi-select
          <div className="col-sm-12 col-md-12 mb-3">
            <label className="form-label fw-bold">Select Stamps for BL</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              name="allStamps"
              components={{
                MultiValueLabel: (props) => (
                  <components.MultiValueLabel {...props}>
                    <div
                      title={props.data.label}
                      style={{
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {props.data.label}
                    </div>
                  </components.MultiValueLabel>
                ),
              }}
              options={[
                ...containerStampOptions.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...descriptionStampOptions.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...measurementStampOptions.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              value={[
                ...selectedStamps.containerStamps.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.descriptionStamps.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.measurementStamps.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              onChange={(options) => {
                const container = [];
                const description = [];
                const measurement = [];

                options?.forEach((opt) => {
                  const [type, value] = opt.value.split(":");
                  if (type === "container") container.push(value);
                  else if (type === "description") description.push(value);
                  else if (type === "measurement") measurement.push(value);
                });

                setSelectedStamps({
                  containerStamps: container,
                  descriptionStamps: description,
                  measurementStamps: measurement,
                });
              }}
              placeholder="Search & Select Stamps"
              classNamePrefix="select"
              isDisabled={!canEdit}
            />
          </div> */}

          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Select Stamps for BL</label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              name="allStamps"
              // Tooltip
              components={{
                MultiValueLabel: (props) => (
                  <components.MultiValueLabel {...props}>
                    <div
                      title={props.data.label}
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {props.data.label}
                    </div>
                  </components.MultiValueLabel>
                ),
              }}
              options={[
                ...containerStampOptions.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...descriptionStampOptions.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...measurementStampOptions.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              value={[
                ...selectedStamps.containerStamps.map((stamp) => ({
                  value: `container:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.descriptionStamps.map((stamp) => ({
                  value: `description:${stamp}`,
                  label: stamp,
                })),
                ...selectedStamps.measurementStamps.map((stamp) => ({
                  value: `measurement:${stamp}`,
                  label: stamp,
                })),
              ]}
              onChange={(options) => {
                const container = [];
                const description = [];
                const measurement = [];

                options?.forEach((opt) => {
                  const [type, value] = opt.value.split(":");
                  if (type === "container") container.push(value);
                  else if (type === "description") description.push(value);
                  else if (type === "measurement") measurement.push(value);
                });

                setSelectedStamps({
                  containerStamps: container,
                  descriptionStamps: description,
                  measurementStamps: measurement,
                });
              }}
              placeholder="Search & Select Stamps"
              classNamePrefix="select"
              styles={{
                control: (base) => ({
                  ...base,
                  maxHeight: "35px",
                  minHeight: "35px",
                  border: "1px solid #ced4da",
                  backgroundColor: "aliceblue",
                  boxShadow: "none",
                  overflow: "hidden",
                  borderRadius: "0.5rem",
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "35px",
                  overflowY: "auto",
                  flexWrap: "nowrap",
                }),
                multiValue: (base) => ({
                  ...base,
                  fontSize: "10px",
                  maxWidth: "90px",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "100px",
                  overflowY: "auto",
                  fontSize: "12px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "#cfe2ff"
                    : state.isFocused
                      ? "#e9ecef"
                      : "#fff",
                  color: "#000",
                  fontWeight: state.isSelected ? "600" : "400",
                }),
              }}
            />
          </div>

          {/* Delivery Agent Selection */}
          <div className="col-sm-6 col-md-4 mb-3">
            <label className="form-label">Delivery Agent</label>
            <Select
              name="deliveryAgent"
              options={deliveryAgentOptions}
              value={deliveryAgentOptions.find((opt) => opt.value === selectedDeliveryAgent)}
              onChange={(option) => setSelectedDeliveryAgent(option ? option.value : "")}
              placeholder="Select Delivery Agent..."
              classNamePrefix="select"
              isDisabled={!canEdit}
            />
          </div>
        </div>

        {/* Submit button - Only visible for authorized users */}
        {canEdit && (
          <div className="d-flex justify-content-end mt-3">
            <Button text="Update Booking" variant="primary" type="submit" />
          </div>
        )}
      </form>

      {/* Confirm Modal - For Quotation Accepted status */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to update this report?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} loading={loadingSubmit} />
        </Modal.Footer>
      </Modal>

      {/* BL Regeneration Confirm Modal - For status other than Quotation Accepted */}
      <Modal show={showBLRegenerateConfirm} onHide={() => !loadingSubmit && setShowBLRegenerateConfirm(false)} centered>
        <Modal.Header closeButton={!loadingSubmit}>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Updating these values will regenerate the existing BL draft? Do you want to regenerate the BL draft?
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="No"
            variant="secondary"
            onClick={handleBLRegenerateNo}
            disabled={loadingSubmit}
          />
          <Button
            text="Yes, Update & Regenerate BL"
            variant="primary"
            onClick={handleBLRegenerateYes}
            loading={loadingSubmit}
          />
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessCloseWithoutDownload} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>{successMessage}</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditContainerStatusReport;

// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import Breadcrumbs from "../../../../components/Breadcrumbs";
// import SectionCards from "./SectionCards";

// const ForwardSectionSelector = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const queryParams = new URLSearchParams(location.search);
//   const jobNumber = queryParams.get("job_number") || "";

//   const handleCardClick = (sectionPath) => {
//     navigate(`/${sectionPath}/${id}`);
//   };

//   return (
//     <>
//       <Breadcrumbs />
//       {/* <div className="d-flex align-items-center mb-4">
//         <Breadcrumbs />

//         <button
//           className="btn btn-sm btn-outline-secondary"
//           onClick={() => navigate(-1)}
//         >
//           ← Back to Job Master
//         </button>
//       </div> */}

//       {jobNumber && (
//         <div className="alert alert-info py-2 px-3 mb-4 d-inline-block rounded-pill shadow-sm small">
//           Active Job :
//           <strong className="text-primary ms-1">#{jobNumber}</strong>
//         </div>
//       )}

//       {/* IMPORTANT */}
//       <SectionCards handleCardClick={handleCardClick} />
//     </>
//   );
// };

// export default ForwardSectionSelector;
